import banner from './components/banner'
import footerTar from './components/footer'
import bigDataService from './components/bigDataService'
import operationFlow from './components/operationFlow'
import digitalEmployees from './components/digitalEmployees'
import serviceCustomer from './components/serviceCustomer'
import newsInfo from './components/newsInfo'
import phone from '../phone/index'
import { listenWindowMixins } from '../../mixin/listenWindow'
export default {
  data () {
    return {
      username: '',
      password: '',
      clientWidth: false,
      one: true,
      currentComponents: [
        {
          key: 0,
          component: 'banner'
        },
        {
          key: 1,
          component: 'bigDataService'
        },
        {
          key: 2,
          component: 'operationFlow'
        },
        {
          key: 3,
          component: 'digitalEmployees'
        },
        {
          key: 4,
          component: 'serviceCustomer'
        },
        {
          key: 5,
          component: 'newsInfo'
        },
        {
          key: 6,
          component: 'footerTar'
        }
      ]
    }
  },
  mixins: [listenWindowMixins],
  components: {
    banner,
    footerTar,
    bigDataService,
    operationFlow,
    digitalEmployees,
    serviceCustomer,
    newsInfo,
    phone
  },
  methods: {
    carouselChange (index) {
      this.currentComponents.forEach((item, imgIndex) => {
        if (index === item.key) {
          this.$refs[item.component][0].moveClass = 'data-text move-after'
        } else {
          this.$refs[item.component][0].moveClass = 'data-text move-before'
        }
      })
    },
    goWheel () {
      if (this.$refs.swiper) {
        if (event.deltaY > 0 && this.one === true) {
          this.$refs.swiper.next()
          this.one = false
          setTimeout(() => {
            this.one = true
          }, 1000)
        }

        if (event.deltaY < 0 && this.one === true) {
          this.$refs.swiper.prev()
          this.one = false
          setTimeout(() => {
            this.one = true
          }, 1000)
        }
      }

    }
  },
  beforeDestroy () {
    window.removeEventListener('wheel', this.goWheel, {
      passive: false
    })
  },
  mounted: function () {
    this.clientWidth = document.documentElement.clientWidth > 1000
    if (this.clientWidth) {
      window.addEventListener('wheel', this.goWheel, {
        passive: false
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/index.js